import { render, staticRenderFns } from "./ContactPaginate.vue?vue&type=template&id=2893b197&scoped=true&"
import script from "./ContactPaginate.vue?vue&type=script&lang=js&"
export * from "./ContactPaginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893b197",
  null
  
)

export default component.exports